import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import PageService from '@/core/page.service';
import { Action, Status } from './registeredproductaction.interface';
import ProductRegistrationActionService from './product-registration-action.service';
import ProductRegistrationService from '@/services/product-registration.service';
import SelfServiceConfirmationModal from '@/ui/shared/modals/SelfServiceConfirmationModal.vue';
import RegisteredProductStatus = Vertica.LouisPoulsen.Application.ProductRegistration.Enums.RegisteredProductStatus;
import RegisteredProductViewObject = Vertica.LouisPoulsen.Application.ProductRegistration.Responses.RegisteredProductViewObject;


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisteredProductActions',
  props: {
    status: null,
    product: null,
    dashboardUrl: null,
    editProductPageUrl: null
  },
  setup(__props: any) {

const props = __props as {
    status: RegisteredProductStatus,
    product: RegisteredProductViewObject,
    dashboardUrl: string,
    editProductPageUrl: string
}



const markAsStolenModal = ref(null);
const markAsNotStolenModal = ref(null);
const markAsSoldModal = ref(null);
const deleteModal = ref(null);

function redirectToEditProductPage() {
    PageService.hardRedirect(props.editProductPageUrl);
}

async function openMarkAsStolenModal() {
    await markAsStolenModal.value.confirm().then(() => {
        ProductRegistrationService.updateProductStatus(props.product.id, Status.Stolen).then(() => {
            ProductRegistrationActionService.SetActionContext(Action.Stolen, props.product.name);
            PageService.softRedirect(props.dashboardUrl);
        });
    }).catch(() => {
        return false;
    });
}

async function openMarkAsNotStolenModal() {
    await markAsNotStolenModal.value.confirm().then(() => {
        ProductRegistrationService.updateProductStatus(props.product.id, Status.Neutral).then(() => {
            ProductRegistrationActionService.SetActionContext(Action.NotStolen, props.product.name);
            PageService.hardReload();
        });
    }).catch(() => {
        return false;
    });
}

async function openMarkAsSoldModal() {
    await markAsSoldModal.value.confirm().then(() => {
        ProductRegistrationService.updateProductStatus(props.product.id, Status.Sold).then(() => {
            ProductRegistrationActionService.SetActionContext(Action.Sold, props.product.name);
            PageService.softRedirect(props.dashboardUrl);
        });
    }).catch(() => {
        return false;
    });
}

async function openDeleteModal() {
    await deleteModal.value.confirm().then(() => {
        ProductRegistrationService.deleteProduct(props.product.id).then(() => {
            ProductRegistrationActionService.SetActionContext(Action.Deleted, props.product.name);
            PageService.softRedirect(props.dashboardUrl);
        });
    }).catch(() => {
        return false;
    });
}

return { __sfc: true,props, markAsStolenModal, markAsNotStolenModal, markAsSoldModal, deleteModal, redirectToEditProductPage, openMarkAsStolenModal, openMarkAsNotStolenModal, openMarkAsSoldModal, openDeleteModal, SelfServiceConfirmationModal }
}

})